






















import { Component, Prop, Watch } from 'vue-property-decorator';
import Vue from 'vue';
import { InputType } from '@/enums/InputType';
import { BrowserHelper } from '@signing-page/helpers/browser.helper';

@Component({
  data: () => ({
    InputType,
  }),
})
export default class Pin extends Vue {
  @Prop({ default: 6 }) pinLength: number;
  @Prop() disabled: boolean;

  values: string[] = [];

  @Watch('values')
  watchingValues() {
    this.$emit('pin', this.values.join(''));
  }

  handleInsertText(value, elementNumber: number) {
    this.setSpecificValue(value, elementNumber);
    if (elementNumber < this.pinLength) {
      const element: HTMLInputElement = this.inputElement(elementNumber);
      element.focus();
    } else {
      const element: HTMLInputElement = this.inputElement(elementNumber - 1);
      element.blur();
    }
  }

  handleIPhoneInputFromSMS(value: string, elementNumber: number) {
    this.setSpecificValue(value, elementNumber);
    if (value.length === this.pinLength) {
      this.values = Array.from(value.toString());
    }
  }

  handlePaste(event: ClipboardEvent, elementNumber: number) {
    const input: string = event.clipboardData.getData('Text');
    const inputs: string[] = input.split('');
    if (inputs.length >= this.pinLength) {
      this.values = inputs.slice(0, this.pinLength);
    } else {
      const valueStart: number = elementNumber - 1;
      const inputCount: number = this.pinLength - elementNumber + 1;
      this.values.splice(valueStart, inputs.length, ...inputs.slice(0, inputCount));
    }
  }

  handleInput(event: any, elementNumber: number) {
    if (event.isTrusted === false) {
      this.handleIPhoneInputFromSMS(event.target.value, elementNumber);
      return;
    }
    if (event.inputType === 'insertText' || BrowserHelper.isIE(window.navigator)) {
      this.handleInsertText(event.target.value, elementNumber);
    }
  }

  setSpecificValue(value: string, elementNumber: number) {
    this.values.splice(elementNumber - 1, 1, value);
  }

  handleFocus(event: KeyboardEvent, elementNumber: number) {
    switch (event.key) {
      case 'ArrowLeft': {
        if (elementNumber === 1) {
          return;
        }
        const element: HTMLInputElement = this.inputElement(elementNumber - 2);
        element.focus();
        return;
      }
      case 'ArrowRight': {
        if (elementNumber === this.pinLength) {
          return;
        }
        const element: HTMLInputElement = this.inputElement(elementNumber);
        element.focus();
        return;
      }
    }
  }

  handleDelete(event: any, elementNumber: number) {
    const index: number = elementNumber - 1;
    event.target.value = '';
    this.values.splice(index, 1, '');
    if (index > 0) {
      const element: HTMLInputElement = this.inputElement(index - 1);
      element.focus();
    }
  }

  inputElement(index: number): HTMLInputElement {
    return document.getElementsByClassName('pin-input')[index] as HTMLInputElement;
  }
}
